// eslint-disable-next-line import/prefer-default-export
export const ORGANISATION_TYPES = {
  COMPANY: 'company',
  FUND: 'fund',
};
